import PropTypes from 'prop-types';
import MainBreadcrumb from '../../../renders/breadcrumb/MainBreadcrumb';
import { SidebarInset, SidebarTrigger, useSidebar } from '@/common-utils/components/ui/sidebar';
import { Separator } from '@/common-utils/components/ui/separator';
import LocalePicker from '@/common-utils/components/renders/localePicker/LocalePicker';
import useResetTableFilters from '@/app/root/hooks/useResetTableFilters';
import useSidebarActiveButtonStore from '@/app/store/sidebarActiveButton';
import { useEffect } from 'react';

/**
 *
 * @param root0
 * @param root0.route
 * @param root0.i18nData
 * @param root0.ids
 * @param root0.children
 * @param root0.isLoading
 * @param root0.prevView
 * @param root0.routeBase
 * @returns {JSX} PageHeader
 */
function PageHeader({ route, i18nData, ids, children, isLoading, prevView, routeBase }) {

    // Store
    const setActiveButton = useSidebarActiveButtonStore(s => s.setActiveButton);

    // Hooks
    useEffect(() => {
        if (routeBase.id) {
            setActiveButton(routeBase.id);
        }
    }, []);

    useResetTableFilters({ routeBaseUrl: routeBase.url });

    const { isMobile } = useSidebar();

    return (
        <div id='page-header' className='page-header flex py-1 overflow-hidden'>
            <SidebarInset>
                <header className='flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12'>
                    <div className='flex items-center gap-2 pl-4'>
                        <SidebarTrigger className='-ml-1' />
                        {(!isMobile || (isMobile && !children)) &&
                            <>
                                <Separator orientation='vertical' className='mr-2 h-4' />
                                <h3 className='page-breadcrumbs'>
                                    <MainBreadcrumb className='page-breadcrumbs' route={route} i18nData={i18nData} ids={ids} isLoading={isLoading} prevView={prevView} />
                                </h3>
                            </>
                        }
                        {
                            children &&
                            <Separator orientation='vertical' className='mr-2 h-4' />
                        }
                    </div>
                    <div className='flex-1  overflow-auto'>
                        {children}
                    </div>
                    {isMobile &&
                        <Separator orientation='vertical' className='ml-2 h-4' />
                    }
                    <div className='mr-4'>
                        <LocalePicker />
                    </div>
                </header>
            </SidebarInset>
        </div>
    );
}

PageHeader.propTypes = {
    route: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        isCustomIcon: PropTypes.bool,
        entity: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func
        ]).isRequired
    }).isRequired,
    i18nData: PropTypes.object,
    ids: PropTypes.object,
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    prevView: PropTypes.string,
    routeBase: PropTypes.object
};

export default PageHeader;